import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { appConfig } from 'shared/appConfig';
import { useModalStore } from 'shared/hooks/stores/useModalStore';
import { useScrollLock } from 'shared/hooks/useScrollLock';

export const ModalContainer = () => {
  const activeModals = useModalStore((state) => state.modals);
  const clearModals = useModalStore((state) => state.clearModals);
  const portalRoot = document.getElementById(appConfig.portalRootId);
  const { lockPageScroll, unlockPageScroll } = useScrollLock();

  useEffect(() => {
    if (activeModals.length) {
      lockPageScroll();
      return;
    }
    unlockPageScroll();
  }, [activeModals]);

  useEffect(() => {
    return () => {
      clearModals();
      unlockPageScroll();
    };
  }, []);

  if (!portalRoot) {
    return null;
  }

  return createPortal(
    <AnimatePresence>
      {activeModals.length > 0 && (
        <motion.div
          key={activeModals[0].id}
          className="fixed inset-0 z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          {activeModals[0].content}
        </motion.div>
      )}
    </AnimatePresence>,
    portalRoot,
  );
};
